import { render, staticRenderFns } from "./StatusStudy.vue?vue&type=template&id=62308f17&"
import script from "./StatusStudy.vue?vue&type=script&lang=js&"
export * from "./StatusStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports